import { parseResponse } from "../../utils/parseResponse";
import { UserProfileInfo, appFriends } from "../../types";
import { userProfileInfoResponseKeys } from "../responseKeys/responseKeys";

export function parseAppFriendsResponse(appFriends: string[]): appFriends {
    return {
        Friends: appFriends.map((el) =>
            parseResponse<UserProfileInfo>(el, userProfileInfoResponseKeys, ['Id', 'CityId'])
        ),
    };
}